/**
 * @generated SignedSource<<d705d5d07c30982173d77fe3e009bdfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportPipedriveOrganizationsInput = {
  clientIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ImportPipedriveOrganizationsMutation$variables = {
  input: ImportPipedriveOrganizationsInput;
};
export type ImportPipedriveOrganizationsMutation$data = {
  readonly importPipedriveOrganizations: {
    readonly clients: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly notes: string | null;
        readonly logoId: string | null;
        readonly logoDefaultId: number | null;
        readonly projectCount: number | null;
        readonly economicCustomerId: string | null;
        readonly quickbooksCustomerId: string | null;
        readonly xeroContactId: string | null;
        readonly salesforceAccountId: string | null;
        readonly hubspotCompanyId: string | null;
        readonly pipedriveOrganizationId: string | null;
        readonly sageIntacctCustomerId: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ImportPipedriveOrganizationsMutation = {
  variables: ImportPipedriveOrganizationsMutation$variables;
  response: ImportPipedriveOrganizationsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportPipedriveOrganizationsPayload",
    "kind": "LinkedField",
    "name": "importPipedriveOrganizations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientTypeEdge",
        "kind": "LinkedField",
        "name": "clients",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Client",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoDefaultId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xeroContactId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveOrganizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctCustomerId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportPipedriveOrganizationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportPipedriveOrganizationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c7ba1cb80cb91cf069c8b97cdf45ed10",
    "id": null,
    "metadata": {},
    "name": "ImportPipedriveOrganizationsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportPipedriveOrganizationsMutation(\n  $input: ImportPipedriveOrganizationsInput!\n) {\n  importPipedriveOrganizations(input: $input) {\n    clients {\n      cursor\n      node {\n        id\n        name\n        notes\n        logoId\n        logoDefaultId\n        projectCount\n        economicCustomerId\n        quickbooksCustomerId\n        xeroContactId\n        salesforceAccountId\n        hubspotCompanyId\n        pipedriveOrganizationId\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e164c7eb0796e90d674cca4c7283279f";

export default node;
